import { Box, Button, Chip, Stack } from "@mui/material";
import { InputControl } from "../../../shared";
import { useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import CloseIcon from "@mui/icons-material/Close";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

export const AddMacDialog = (props) => {
  const {
    onChange,
    handleAddMacId,
    handleDeleteMacTag,
    onSubmit,
    state,
    handleClose,
  } = props;

  const [, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const OnAdd = () => {
    console.log("state.macId, ", state.macId, validator.current);

    if (validator.current.allValid()) {
      console.log("state.macId, ", state.macId);

      handleAddMacId();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  return (
    <>
      <Box sx={{ p: "16px" }}>
        <Stack
          sx={{
            flexDirection: "row",
            gap: "8px",
            alignItems: "baseline",
          }}
        >
          <InputControl
            name="name"
            type="text"
            label="MAC ID"
            required
            sx={{ width: "100%" }}
            error={
              state.macId &&
              validator.current.message("MAC ID", state.macId, [
                "required",
                {
                  regex:
                    /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})|([0-9a-fA-F]{4}\\.[0-9a-fA-F]{4}\\.[0-9a-fA-F]{4})$/,
                },
              ])
            }
            helperText={
              state.macId &&
              validator.current.message("MAC ID", state.macId, [
                "required",
                {
                  regex:
                    /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})|([0-9a-fA-F]{4}\\.[0-9a-fA-F]{4}\\.[0-9a-fA-F]{4})$/,
                },
              ])
            }
            onChange={onChange}
            value={state.macId}
          />
          <Button
            variant="contained"
            onClick={OnAdd}
            sx={{
              height: "40px",
            }}
            disabled={!state.macId}
          >
            ADD
          </Button>
        </Stack>
        <Stack
          sx={{
            flexDirection: "row",
            gap: "8px",
            flexWrap: "wrap",
            py: "8px",
            maxHeight: "calc(90vh - 204px)",
            overflowY: "auto",
          }}
        >
          {state.addMacs.map((data) => (
            <Chip
              variant="outlined"
              color="gray"
              label={data}
              deleteIcon={
                <CloseIcon sx={{ height: "16px", color: "#000 !important" }} />
              }
              onDelete={() => {
                handleDeleteMacTag(data);
              }}
            />
          ))}
        </Stack>
      </Box>
      <CustomDialogFooter
        onSubmit={onSubmit}
        handleClose={handleClose}
        disabled={!state.addMacs.length > 0}
      />
    </>
  );
};
